<!-- ReviewCard — calm borderless card shell for one chart in the Review tab.
     Headline ≥18px. Optional note line at 15px. Chart content via snippet. -->
<script lang="ts">
  import type { Snippet } from "svelte";

  interface Props {
    headline: string;
    note?: string;
    children: Snippet;
  }
  let { headline, note, children }: Props = $props();
</script>

<div class="review-card">
  <h2 class="headline">{headline}</h2>
  {#if note}
    <p class="note">{note}</p>
  {/if}
  <div class="chart-slot">
    {@render children()}
  </div>
</div>

<style>
  .review-card {
    /* Near-solid scrim so cards read consistently regardless of where they sit
       over the background photo. --bg-card is 42% opaque (Dawn Glass global),
       which bleeds on the brighter lower (sunrise) region where card 3 sits.
       Override to 0.92 + blur here so all three cards look identical. */
    background: rgba(16, 17, 21, 0.92);
    border: 0;
    border-radius: var(--radius-card, 14px);
    padding: var(--space-6, 20px) var(--space-4, 16px) var(--space-4, 16px);
    backdrop-filter: blur(22px) saturate(1.2);
    -webkit-backdrop-filter: blur(22px) saturate(1.2);
    margin-bottom: var(--space-4, 16px);
  }

  /* 18px floor per spec — "always-visible" landmark for a distracted user. */
  .headline {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary, #e4e2e4);
    margin: 0 0 var(--space-2, 8px);
    line-height: 1.3;
  }

  /* 15px floor per spec — supplementary glide note. */
  .note {
    font-size: 15px;
    color: var(--text-muted);
    margin: 0 0 var(--space-3, 12px);
    line-height: 1.4;
  }

  .chart-slot {
    width: 100%;
  }
</style>
